import { render, staticRenderFns } from "./SendSpam.vue?vue&type=template&id=88c692e6&scoped=true&"
import script from "./SendSpam.vue?vue&type=script&lang=js&"
export * from "./SendSpam.vue?vue&type=script&lang=js&"
import style0 from "./SendSpam.vue?vue&type=style&index=0&id=88c692e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c692e6",
  null
  
)

export default component.exports